import { call, put, take, takeLatest, select } from "redux-saga/effects";

import types from "./types";
import api from "./api";
import actions from "./actions";

export function* get_categories(action) {
  const { products } = action.payload;
  const { data } = yield api.get_categories();

  yield put(
    actions.set_categories({
      categories: data,
      products,
    })
  );
}

export default [takeLatest(types.GET_CATEGORIES_REQUEST, get_categories)];
